// extracted by mini-css-extract-plugin
export default {"NavigationMenu":"MobileNavigation_NavigationMenu__yiMBg","burgerButton":"MobileNavigation_burgerButton__h2bqs"};